import { defineComponent as _defineComponent } from 'vue'

export enum OzDropdownButtonSizePreset {
  H40px = 'H40px',
  H32px = 'H32px',
}

export enum OzDropdownButtonColorScheme {
  Secondary = 'Secondary',
  SecondaryClear = 'SecondaryClear',
  SecondaryClearActive = 'SecondaryClearActive',
  SecondaryClearText = 'SecondaryClearText',
}

const __default__ = {}

import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzDropdownButton',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    dir: { default: 'auto' },
    sizePreset: { default: OzDropdownButtonSizePreset.H40px },
    colorScheme: { default: OzDropdownButtonColorScheme.Secondary },
    text: { default: undefined },
    startIconName: { default: undefined },
    disabled: { type: Boolean, default: false },
    shouldTruncateText: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any) {

/**
 * @file The main differences between OzDropdownButton and OzContainedButton are:
 *
 * - Font weight
 * - Text color
 * - Transparent background instead of disabled color background
 * - No active state
 * - Padding
 * - Space between text and icon
 */




return { __sfc: true,OzDropdownButtonSizePreset, OzDropdownButtonColorScheme, OzBaseButton, OzIcon }
}

})